const initialState = {
  sites: [],
  contents: []
};
function rootReducer(state = initialState, action) {
  return state;
};
export default rootReducer;